/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Card, Col, Image, Radio, Row, Switch } from "antd";
import {
  InputField,
  InputTextArea,
  SelectField,
} from "../../../../../../atoms/FormFields";
import { useEffect, useState } from "react";
import UploadPhoto from "../../../../../../atoms/UploadPhoto";
import Meta from "antd/es/card/Meta";
import { RefreshIcon } from "../../../../../../atoms/CustomIcons";
import { FieldErrors } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../../../../../config/hooks";
import { onImageDelete } from "../../../../../MyProfile/ducks/services";
import { SuccessMessage } from "../../../../../../atoms/Toasts/SuccessMessage";
import { getServiceDetails } from "../../../ducks/actions";
import { ErrorMessage } from "../../../../../../atoms/Toasts/ErrorMessage";
import { ServiceLineListingType } from "../../../ducks/types";

// Define or import the FormValues type
interface FormValues {
  name: string;
  description?: string;
  frequency?: string;
  quantity_unit?: string;
  take_off?: string;
  production_rate?: number;
  subcontractors?: string[];
  service_timeframe?: [string, string];
  frequency_status?: string;
}

interface PropsType {
  control: any;
  setLoading: (loading: boolean) => void;
  errors: FieldErrors<FormValues>;
  serviceType: string;
  setValue: any;
  frequencyType: string;
  takeOff: boolean;
  checklistFile: File | null;
  type: string | null;
  serviceId: string | undefined;
  isTakeOff: React.Dispatch<React.SetStateAction<boolean>>;
  setFrequencyType: React.Dispatch<React.SetStateAction<string>>;
  setServiceType: React.Dispatch<React.SetStateAction<string>>;
  setChecklistFile: React.Dispatch<React.SetStateAction<File | null>>;
  serviceDetailData: ServiceLineListingType | null;
  setTakeOffType: React.Dispatch<React.SetStateAction<string>>;
}

const frequencyList: { value: string; label: string }[] = [
  { value: "weekly", label: "Weekly" },
  { value: "bi_weekly", label: "Bi-weekly" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly" },
];

export default function GeneralTab(props: PropsType) {
  const {
    control,
    setLoading,
    errors,
    setServiceType,
    serviceType,
    setValue,
    takeOff,
    type,
    isTakeOff,
    frequencyType,
    checklistFile,
    setChecklistFile,
    setFrequencyType,
    serviceId,
    serviceDetailData,
    setTakeOffType,
  } = props;

  const serviceFormData = useAppSelector(
    (state) => state?.services?.serviceFormData
  );
  const dispatch = useAppDispatch();

  // local UI state to match UploadPhoto's API
  const [previewImage, setPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });
  const [modalPreviewImage, setModalPreviewImage] = useState<{
    file: string;
    imagePreviewUrl: string | null;
  }>({ file: "", imagePreviewUrl: null });
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const [, setIsCropModalOpen] = useState<boolean>(false);

  const saveUpload = () => {
    // preserve existing behavior: inform parent we're loading while saving
    setLoading(true);
    setPreviewImage({ ...modalPreviewImage });
    setLoading(false);
    setUploadModal(false);
  };

  const onChange = (checked: boolean) => {
    isTakeOff(checked);
  };

  const onSelectChange = (value: string | number | readonly string[]) => {
    const selectedTakeOff: any =
      serviceFormData?.data?.takeoff &&
      serviceFormData?.data?.takeoff?.find(
        (takeOff: { value: string }) => takeOff?.value === value
      );
    setTakeOffType(selectedTakeOff?.unit);
    if (selectedTakeOff && selectedTakeOff?.unit) {
      setValue(
        "take_off_unit",
        `${selectedTakeOff?.unit} (${selectedTakeOff?.unit_name})`
      );
    } else {
      setValue("take_off_unit", "");
    }
  };

  const onSelectChangeUnit = (value: string | number | readonly string[]) => {
    const selectedTakeOff: any =
      serviceFormData?.data?.units &&
      serviceFormData?.data?.units?.find(
        (unit: { value: string }) => unit?.value === value
      );
    setTakeOffType(selectedTakeOff?.unit);
  };

  function callMembersAPI() {
    if (serviceId) {
      dispatch(getServiceDetails(serviceId as string));
    }
  }

  useEffect(() => {
    if (serviceDetailData?.unit_id) {
      const selectedTakeOff: any =
        serviceFormData?.data?.units &&
        serviceFormData?.data?.units?.find(
          (unit: { value: string }) =>
            unit?.value === serviceDetailData?.unit_id
        );
      setTakeOffType(selectedTakeOff?.unit);
    } else if (serviceDetailData?.takeoff_id) {
      const selectedTakeOff: any =
        serviceFormData?.data?.takeoff &&
        serviceFormData?.data?.takeoff?.find(
          (unit: { value: string }) =>
            unit?.value === serviceDetailData?.takeoff_id
        );
      setTakeOffType(selectedTakeOff?.unit);
      if (selectedTakeOff && selectedTakeOff?.unit) {
        setValue(
          "take_off_unit",
          `${selectedTakeOff?.unit} (${selectedTakeOff?.unit_name})`
        );
      } else {
        setValue("take_off_unit", "");
      }
    } else {
      setTakeOffType("...");
    }
  }, [serviceDetailData, setValue, serviceFormData, setTakeOffType]);

  // const FrequencyOptions = [
  //   { label: "Monthly", value: "monthly" },
  //   { label: "Quarterly", value: "quarterly" },
  //   { label: "Biannually", value: "biannually" },
  //   { label: "Annually", value: "annually" },
  // ];

  return (
    <div className="tabs_content">
      <Card className="service_tabs_card">
        <h4 style={{ marginBottom: "16px" }}>General details</h4>
        <Row>
          <Col span={24} style={{ marginBottom: "24px" }}>
            <UploadPhoto
              saveUpload={saveUpload}
              loading={false}
              uploadModal={uploadModal}
              setUploadModal={setUploadModal}
              previewImage={previewImage}
              checklistFile={checklistFile}
              modalPreviewImage={modalPreviewImage}
              setChecklistFile={setChecklistFile}
              setPreviewImage={setPreviewImage}
              setModalPreviewImage={setModalPreviewImage}
              setIsCropModalOpen={setIsCropModalOpen}
              imageUploaded={serviceDetailData?.image_url}
              onImageDelete={() => {
                onImageDelete(
                  setLoading,
                  SuccessMessage,
                  callMembersAPI,
                  ErrorMessage,
                  serviceDetailData?.image_url
                    ? serviceDetailData?.image_id
                    : undefined
                );
              }}
              infoTextUploader={
                "Use the picture in proposals and help others identify this service. It’s optional."
              }
            />
          </Col>
          <Col span={24}>
            <InputField
              fieldName="name"
              label="Service name"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "Enter Service name",
              }}
              isRequired
              rules={{
                required: "Service name is required.",
              }}
              validate={errors.name && "error"}
              validMessage={errors.name && errors.name.message}
            />
          </Col>
          <Col span={24}>
            <InputTextArea
              fieldName="description"
              label="Description"
              control={control}
              defaultValue=""
              iProps={{
                placeholder: "A brief description for internal purposes ...",
              }}
              tooltipTitle="This will be visible to your customers."
            />
          </Col>

          {type === "simple" && (
            <Col span={24}>
              <div className="label_text" style={{ paddingBottom: 6 }}>
                How the service is provided:
              </div>
              <div className="service_type_card service_line_card">
                <Radio.Group
                  onChange={(e) => setServiceType(e.target.value)}
                  value={serviceType}
                >
                  <Radio.Button value="in_house">
                    <Card>
                      <Meta
                        avatar={
                          <Image
                            src="/images/services/in-house-icon.svg"
                            alt="filled"
                            preview={false}
                            width={56}
                            height={56}
                          />
                        }
                        title="In-house"
                        description="Performed by the company using internal labor."
                      />

                      <div className="checkbox_image">
                        <Image
                          src="/images/services/radio-filled.svg"
                          alt="filled"
                          preview={false}
                          className="checkbox-filled"
                        />
                        <Image
                          src="/images/services/radio-unfilled.svg"
                          alt="un-filled"
                          preview={false}
                          className="checkbox-unfilled"
                        />
                      </div>
                    </Card>
                  </Radio.Button>
                  <Radio.Button value="subcontracted">
                    <Card>
                      <Meta
                        avatar={
                          <Image
                            src="/images/services/subcontracted-icon.svg"
                            alt="filled"
                            preview={false}
                            width={56}
                            height={56}
                          />
                        }
                        title="Subcontracted"
                        description="Outsourced to an external vendor or contractor."
                      />

                      <div className="checkbox_image">
                        <Image
                          src="/images/services/radio-filled.svg"
                          alt="filled"
                          preview={false}
                          className="checkbox-filled"
                        />
                        <Image
                          src="/images/services/radio-unfilled.svg"
                          alt="un-filled"
                          preview={false}
                          className="checkbox-unfilled"
                        />
                      </div>
                    </Card>
                  </Radio.Button>
                </Radio.Group>
              </div>
            </Col>
          )}
          <Col span={24}>
            <div className="label_text" style={{ paddingBottom: 6 }}>
              Service frequency:
            </div>
            <div
              className="service_type_card service_line_card"
              style={{ paddingBottom: 0 }}
            >
              <Radio.Group
                onChange={(e) => setFrequencyType(e.target.value)}
                value={frequencyType}
              >
                <Radio.Button value="one_time">
                  <Card>
                    <Meta
                      avatar={
                        <Image
                          src="/images/services/time-icon.svg"
                          alt="filled"
                          preview={false}
                          width={56}
                          height={56}
                        />
                      }
                      title="One-time"
                      description="Performed once per contract, such as a spring clean-up or an installation job."
                    />

                    <div className="checkbox_image">
                      <Image
                        src="/images/services/radio-filled.svg"
                        alt="filled"
                        preview={false}
                        className="checkbox-filled"
                      />
                      <Image
                        src="/images/services/radio-unfilled.svg"
                        alt="un-filled"
                        preview={false}
                        className="checkbox-unfilled"
                      />
                    </div>
                  </Card>
                </Radio.Button>
                <Radio.Button value="recurring">
                  <Card>
                    <Meta
                      avatar={
                        <Image
                          src="/images/services/time-icon.svg"
                          alt="filled"
                          preview={false}
                          width={56}
                          height={56}
                        />
                      }
                      title="Recurring"
                      description="Performed regularly during visits, like a weekly service or irrigation wet check."
                    />

                    <div className="checkbox_image">
                      <Image
                        src="/images/services/radio-filled.svg"
                        alt="filled"
                        preview={false}
                        className="checkbox-filled"
                      />
                      <Image
                        src="/images/services/radio-unfilled.svg"
                        alt="un-filled"
                        preview={false}
                        className="checkbox-unfilled"
                      />
                    </div>
                  </Card>
                </Radio.Button>
              </Radio.Group>
            </div>
          </Col>
        </Row>
      </Card>
      {frequencyType === "recurring" && type === "simple" && (
        <Card>
          <div className="card_top">
            <div className="card_left">
              <h4
                style={{
                  marginBottom: "4px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                }}
              >
                Recurrence settings
                <Button className="refreshIcon">
                  <RefreshIcon />
                </Button>
              </h4>
              <p style={{ marginBottom: "16px" }}>
                Set how frequently the service is provided. Leave empty if it
                varies by property or none of the suggested options work.
                Managers will specify the number of visits directly in the
                estimates.
              </p>
            </div>
          </div>

          <SelectField
            fieldName="frequency"
            label="Frequency"
            control={control}
            selectOption={frequencyList}
            iProps={{
              placeholder: "Choose frequency",
            }}
            className="bottom_0"
            isRequired
            rules={{
              required: "Frequency is required.",
            }}
            validate={errors.frequency && "error"}
            validMessage={errors.frequency && errors.frequency.message}
          />
        </Card>
      )}

      {/* <Card>
        <h4 style={{ marginBottom: "4px" }}>Service schedule</h4>
        <p style={{ marginBottom: "16px" }}>
          Set when this service is typically provided.
        </p>

        <DateRangeField
          fieldName="service_timeframe"
          label="Service timeframe"
          control={control}
          iProps={{
            placeholder: "Mon, DD, YYYY",
          }}
          className="bottom_0 service_timeframe_field"
          tooltipTitle="Service timeframe"
        />

        <Row gutter={16}>
          <Col span={16}>
            <SelectField
              fieldName="frequency"
              label="Frequency"
              control={control}
              selectOption={FrequencyOptions}
              iProps={{ placeholder: "Select frequency" }}
              defaultValue="Monthly"
              isRequired
              rules={{
                required: "Frequency is required.",
              }}
              validate={errors.frequency && "error"}
              validMessage={errors.frequency && errors.frequency.message}
            />
          </Col>
          <Col span={8}>
            <InputNumberField
              fieldName="interval_between_visits"
              label="Interval between visits"
              control={control}
              iProps={{
                placeholder: "Min — Max days",
              }}
            />
          </Col>
        </Row>

        <div className="visible_monthly_visit">
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div className="title_switch">
              <h4> Variable monthly visits and hours </h4>
              <p style={{ marginBottom: "14px" }}>
                If enabled, managers can distribute total contract visits and
                hours unevenly across months to reflect seasonal workload.
              </p>
            </div>
            <Switch />
          </div>

          <Button
            htmlType="button"
            className="outlined-btn"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "190px" }}
          >
            <PencilIcon /> Edit default setup
          </Button>

          <Alert
            message={
              <>
                The default setup applies each time the contract is sent to
                production. The{" "}
                <span style={{ color: "#6454F4", fontWeight: "600" }}>
                  Production manager
                </span>{" "}
                must review and confirm the hour allocation for the contract.
              </>
            }
            type="success"
            style={{ marginTop: "20px" }}
            showIcon
            icon={<InfoIconOutlined />}
            className="alert_info_box"
          />
        </div>
      </Card> */}

      {type === "simple" && (
        <Card>
          <h4 style={{ marginBottom: "4px" }}>Service quantity measurement</h4>
          <p style={{ marginBottom: "16px" }}>
            Define service quantity units (e.g. square foot, cubic yard) to
            calculate its costs in estimates.
          </p>

          <div
            className="switchBox"
            style={{
              marginBottom: "16px",
              padding: "10px 0",
              fontSize: "14px",
            }}
          >
            <Switch onChange={onChange} checked={takeOff} />
            Use property takeoff measurement
          </div>

          {takeOff ? (
            <Row gutter={8}>
              <Col span={14}>
                <SelectField
                  fieldName="take_off"
                  label="Takeoff measurement"
                  control={control}
                  selectOption={serviceFormData?.data?.takeoff ?? []}
                  iProps={{
                    placeholder: "Select unit",
                  }}
                  onSelectChange={onSelectChange}
                  className="bottom_0"
                  isRequired
                  rules={{
                    required: "Takeoff measurement is required.",
                  }}
                  validate={errors.take_off && "error"}
                  validMessage={errors.take_off && errors.take_off.message}
                />
              </Col>
              <Col span={10}>
                <InputField
                  fieldName="take_off_unit"
                  label="Service quantity unit"
                  control={control}
                  iProps={{
                    placeholder: "Quantity unit",
                    disabled: true,
                  }}
                  className="bottom_0"
                />
              </Col>
            </Row>
          ) : (
            <SelectField
              fieldName="quantity_unit"
              label="Service quantity unit"
              control={control}
              selectOption={
                serviceFormData?.data?.units &&
                serviceFormData?.data?.units?.length > 0
                  ? serviceFormData?.data?.units?.map(
                      (unit: {
                        unit: string;
                        label: string;
                        value: string;
                      }) => ({
                        label: `${unit?.unit} (${unit?.label})`,
                        value: unit?.value ?? unit?.unit,
                      })
                    )
                  : []
              }
              iProps={{
                placeholder: "Select unit",
              }}
              onSelectChange={onSelectChangeUnit}
              className="bottom_0"
              isRequired
              rules={{
                required: "Service quantity unit is required.",
              }}
              validate={errors.quantity_unit && "error"}
              validMessage={
                errors.quantity_unit && errors.quantity_unit.message
              }
            />
          )}
        </Card>
      )}
    </div>
  );
}
